import React                                                        from 'react';
import { withStyles }                                               from '@material-ui/core/styles';
import {colores, globales,funciones}                                          from '../global';
import AuthService                                                  from '../AuthService';
import Request                                                      from 'superagent';
import CircularProgress                                             from '@material-ui/core/CircularProgress';
import Box                    from '@material-ui/core/Box';
import Iconos                 from './Icono';
import Card                   from '@material-ui/core/Card';
import CardHeader             from '@material-ui/core/CardHeader';
import CardContent            from '@material-ui/core/CardContent';
import Button                 from '@material-ui/core/Button';
import Paper                  from '@material-ui/core/Paper';
import Grid                   from '@material-ui/core/Grid';
import Avatar                               from '@material-ui/core/Avatar';
import Typography             from '@material-ui/core/Typography';
import { Divider, IconButton }            from '@material-ui/core';
import FormControlLabel                     from '@material-ui/core/FormControlLabel';
import { Bar,Line, Pie  } from 'react-chartjs-2';
import Slider                                   from '@material-ui/core/Slider';
import                                            '../CSS/Style_widgets.css'

let Auth = new AuthService();
var ip=globales.ip
var widgets_interval
var movil_pequeño=/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

var border_dialog=globales.border_dialog
var color_fondo='linear-gradient(to top right ,rgba(3,25,48,1),rgba(3,25,48,0.8))'

/*                           CLASES DE ESTILO                       */

var styles = theme =>({
  Dialog:{
    borderRadius: border_dialog,
    margin:0,
    padding:0
  },
    media: {
        // ⚠️ object-fit is not supported by IE11.
        objectFit: 'cover',
  
      },
})

const PrettoSlider = withStyles({
  root: {
    color: colores.naranja,
    height: 5,
  },
  thumb: {
    height: 20,
    width: 20,
    backgroundColor: colores.naranja,
    border: '1px solid white',
    marginTop: -7,
    marginLeft: -12,
    '&:focus, &:hover, &$active': {
     
    },
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 4px)',
  },
  track: {
    height: 5,
    borderRadius: 4,
  },
  rail: {
    height: 5,
    borderRadius: 4,
  },
})(Slider);

const marks = [{value: 0,},{value: 20,},{value: 50,},{value: 80,},{value: 100,},];

function WidgetLine(props){
  //var hora=props.actualizacion.getHours()
  //var minutos=props.actualizacion.getMinutes()<10?'0'+props.actualizacion.getMinutes():props.actualizacion.getMinutes()
  //var formato=hora<12?' a.m.':''
  const data = {
    labels: props.labels,
    datasets: [
      {
        label: props.label,
        fill: true,
        backgroundColor: 'rgba('  +colores.naranja_rgb+',0.1)',
        borderColor: 'rgba('  +colores.naranja_rgb+',0.5)',
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: 'miter',
        pointBorderColor: 'rgba('  +colores.azul_rgb+',0.7)',
        pointBackgroundColor: 'rgba('  +colores.azul_rgb+',0.7)',
        pointBorderWidth: 1,
        pointHoverRadius: 13,
        pointHoverBackgroundColor: 'rgba('  +colores.azul_rgb+',0.7)',
        pointHoverBorderColor: 'rgba('  +colores.naranja_rgb+',0.7)',
        pointHoverBorderWidth: 1,
        pointRadius: 3,
        pointHitRadius: 10,
        lineTension: 0.4,
        data: props.data
      }
    ]
  };  
  return(
  <Card key={'Card-'+props.keyg} 
  className={movil_pequeño?'WidgetLine-movil':localStorage.getItem('switch')==='false'?'WidgetLine-pc-sm':'WidgetLine-pc'}
  style={{background: 'linear-gradient(to top right ,rgba('+props.BACKGROUND_RGB+',1),rgba('+props.BACKGROUND_RGB+',0.8))' }}>
      <Line key={'Line-'+props.keyg}  data={data} options={{responsive: true,scales: {
        yAxes: [
          {
            gridLines: {color:'#373737'},ticks:{fontColor:'#A7A7A7',fontStyle:'normal'}
          }
        ],
        xAxes: [
          {
            gridLines: {color:'#373737'},ticks:{fontColor:'#BFBFBF',fontStyle:'normal'}
          }
        ]
      }
        ,legend: {display: false},title: {display: true,text: props.label,fontColor: '#BFBFBF',fontSize: '14',fontStyle:'normal'},}}
      />
      <Typography align='right' variant="caption" component="div" style={{fontSize:11,marginRight:5,marginaBottom:0,marginTop:3,color:'grey'}}>
        {//'Ult. Act: '+ hora+':'+minutos+formato
        }
      </Typography>
  </Card>
  );
}

function WidgetBar(props){
  //var hora=props.actualizacion.getHours()
  //var minutos=props.actualizacion.getMinutes()<10?'0'+props.actualizacion.getMinutes():props.actualizacion.getMinutes()
  //var formato=hora<12?' a.m.':''
    const data = {
      labels: props.labels,
      datasets: [
        {
          label: props.label,
          fill: false,
          backgroundColor: 'rgba('+colores.azul_rgb+',0.7)',
          borderColor: 'transparent',
          hoverBackgroundColor: 'rgba('+colores.naranja_rgb+',0.7)',
          hoverBorderColor: 'rgba('+colores.naranja_rgb+',0.7)',
          borderWidth: 0,
          data: props.data
        }
      ]
    };  
 
    return(
    <Card key={'Card-'+props.keyg} 
    className={movil_pequeño?'WidgetBar-movil':localStorage.getItem('switch')==='false'?'WidgetBar-pc-sm':'WidgetBar-pc'}
    style={{background: 'linear-gradient(to top right ,rgba('+props.BACKGROUND_RGB+',1),rgba('+props.BACKGROUND_RGB+',0.8))'}}>
        <Bar key={'Bar-'+props.keyg}  data={data} 
        options={{maintainAspectRatio : true, responsive: true
          ,scales: {yAxes: [{color:'white',gridLines: {color:'#353535'}
        ,ticks: {max: props.max,min:props.min,stepSize: props.stepSize,fontColor:'#A7A7A7',fontStyle:'normal'}}]
        ,xAxes: [{gridLines: {color:'#353535'},ticks:{fontColor:'#BFBFBF',fontStyle:'normal'}}]
      },
          plugins: {legend: false},legend: {display: false,},title: {display: true,text: props.label,fontColor: '#BFBFBF',fontSize: '13',fontStyle:'normal'},
      }}/>
      <Typography align='right' variant="caption" component="div" style={{fontSize:11,marginRight:5,marginaBottom:0,marginTop:3,color:'grey'}}>
        {//'Ult. Act: '+ hora+':'+minutos+formato
        }
      </Typography>
    </Card>
    );
}

function WidgetPie(props){
  //var hora=props.actualizacion.getHours()
  //var minutos=props.actualizacion.getMinutes()<10?'0'+props.actualizacion.getMinutes():props.actualizacion.getMinutes()
  //var formato=hora<12?' a.m.':''

  const data = {
    label: props.label,
    labels: props.labels,
    datasets: [{
        data: props.data,
        backgroundColor: props.color_label,
        hoverOffset: 5,
        borderColor:'white',borderWidth: 1,hoverBorderColor: props.color_label,
      },
    ]
  }

  return(
    <Card key={'Card-'+props.keyg} 
    className={movil_pequeño?'WidgetPie-movil':localStorage.getItem('switch')==='false'?'WidgetPie-pc-sm':'WidgetPie-pc'}
    style={{background: 'rgba('+props.BACKGROUND_RGB+',0.9)'}}>
    <Pie key={'Pie-'+props.keyg} data={data} 
    options={{ maintainAspectRatio: true,cutoutPercentage: 40,responsive:true
     ,legend:{ fullWidth:true, display:true,position:"right",labels: {boxWidth: 15,fontColor: '#BFBFBF'}}
     ,title: {display: true,text: props.label,fontColor: '#BFBFBF',fontSize: '15',fontStyle:'normal'}
     ,layout: {padding: {left: 0,right: 0,top:0,bottom:0}}
     ,scales:{yAxes:[{gridLines:{color: 'rgba(255,255,255,0.1)'},ticks:{beginAtZero: true,fontColor:'transparent'}}],}
     ,animation: {animateRotate: false,animateScale: true}
     ,tooltips: {intersect: false,mode: 'index',
      callbacks: {
        label: function(tooltipItem, data) {
          var dataset = data.datasets[tooltipItem.datasetIndex];
          var meta = dataset._meta[Object.keys(dataset._meta)[0]];
          var total = meta.total;
          var currentValue = dataset.data[tooltipItem.index];
          var percentage = parseFloat((currentValue/total*100).toFixed(1));
          return '(' + percentage + '%)';//currentValue + 
          
        },
        title: function(tooltipItem, data) {
          return data.labels[tooltipItem[0].index];
        }
      }
    }    
    }}
    />
    <Typography align='right' variant="caption" component="div" style={{fontSize:11,marginRight:5,marginaBottom:0,marginTop:3,color:'grey'}}>
      {//'Ult. Act: '+ hora+':'+minutos+formato
      }
    </Typography>
    </Card>
    );
}


function WidgetCirculos(props){
  //var hora=props.actualizacion.getHours()
  //var minutos=props.actualizacion.getMinutes()<10?'0'+props.actualizacion.getMinutes():props.actualizacion.getMinutes()
  //var formato=hora<12?' a.m.':''
    return(
    <Card className={movil_pequeño?'WidgetCirculos-movil':localStorage.getItem('switch')==='false'?'WidgetCirculos-pc-sm':'WidgetCirculos-pc'} style={{background: 'linear-gradient(to top right ,rgba('+props.BACKGROUND_RGB+',1),rgba('+props.BACKGROUND_RGB+',0.8))'}}>
              <CardHeader title={props.titulo} style={{color: 'white',paddingTop:1,paddingLeft:1}} avatar={<Avatar style={{background: 'transparent'}}>
                <Iconos fontSize='small' icono={props.icono}  />
                </Avatar>} />
              <CardContent style={{justifyContent:'center',display:'flex'}}>
              <Grid container>
              <Grid item xs={4}>
              <FormControlLabel labelPlacement={'top'}
              control={
              <Box position="relative" display="inline-flex" style={{marginTop:10}}>
              <CircularProgress thickness={5} size={65} variant="determinate" value={props.porcentaje1?parseFloat(props.valor1):100} style={{color: 'green'}}/>
              <Box top={0}left={0}bottom={0}right={0} position="absolute" display="flex" alignItems="center" justifyContent="center">
                <Typography variant="caption" component="div" style={{color:'white'}}>{`${Math.round(props.valor1)+props.simbolo1}`}</Typography>
              </Box>
              </Box>} label={props.label1}  style={{color:'white' ,display: 'flex',marginLeft: 5}}/>
              </Grid>
              <Grid item xs={4}>
              <FormControlLabel labelPlacement={'top'}
              control={
              <Box position="relative" display="inline-flex" style={{marginTop:10}}>
              <CircularProgress thickness={5} size={65} variant="determinate" value={props.porcentaje2?parseFloat(props.valor2):100} style={{color: 'green'}}/>
              <Box top={0}left={0}bottom={0}right={0} position="absolute" display="flex" alignItems="center" justifyContent="center">
                <Typography variant="caption" component="div" style={{color:'white'}}>{`${Math.round(props.valor2)+props.simbolo2}`}</Typography>
              </Box>
              </Box>} label={props.label2} style={{color:'white' ,display: 'flex',marginLeft: 5}}/>
              </Grid>
              <Grid item xs={4}>
              <FormControlLabel labelPlacement={'top'}
              control={
              <Box position="relative" display="inline-flex" style={{marginTop:10}}>
              <CircularProgress thickness={5} size={65} variant="determinate" value={props.porcentaje3?parseFloat(props.valor3):100} style={{color: 'red'}}/>
              <Box top={0}left={0}bottom={0}right={0} position="absolute" display="flex" alignItems="center" justifyContent="center">
                <Typography variant="caption" component="div" style={{color:'white'}}>{`${Math.round(props.valor3)+props.simbolo3}`}</Typography>
              </Box>
              </Box>} label={props.label3}  style={{color:'white' ,display: 'flex',marginLeft: 5}}/>
              </Grid>
              </Grid>
              </CardContent>
              <Typography align='right' variant="caption" component="div" style={{fontSize:11,marginaBottom:0,marginTop:5,color:'grey'}}>
                {//'Ult. Act: '+ hora+':'+minutos+formato
                }
              </Typography>
          </Card>
    );
}

function WidgetFechas(props){
    return(
<Card className={movil_pequeño?'WidgetFechas-movil':localStorage.getItem('switch')==='false'?'WidgetFechas-pc-sm':'WidgetFechas-pc'} style={{background: color_fondo}}>
<CardHeader title={'Fechas Control Matrícula '+props.año+'-'+props.periodo} style={{color: 'white',paddingTop:1,paddingLeft:1,paddingBottom:0}} avatar={<Avatar style={{background: 'transparent'}}>
          <Iconos fontSize='small' icono={'Time'}  />
          </Avatar>} />
                         
                          <Paper style={{margin: 5, padding: 5, background: 'transparent'}}>
                          <Grid container style={{background:'transparent', verticalAlign:'middle',height: movil_pequeño?window.innerHeight-300:'auto'}}>
                          
                          <Grid item xs  style={{align: 'center',verticalAlign: 'middle',padding: 0, margin: 0}}>
                            <Paper style={{color:'white',background: 'transparent'
                            ,boxShadow:'inherit'
                              ,padding: 2,paddingBottom: 0, marginRight: 0, marginBottom: movil_pequeño?0:3, borderRadius:0
                              }} align='center' >
                              Período
                            </Paper>
                           <Divider style={{backgroundColor: 'white'}} />
                          </Grid>
                          <Grid container item  style={{verticalAlign:'middle',width:'100%'}}>
                              <Grid item xs >
                                <Paper style={{width:'100%',color: 'white',boxShadow:'inherit',background: 'transparent',padding:5, borderRadius:0, }} align='center'> {props.fecha_per_inicio} </Paper>
                              </Grid>
                              <Grid item xs>
                                <Paper style={{width:'100%',color:'white',boxShadow:'inherit',background: 'transparent',padding:5, borderRadius:0, }} align='center'> {props.fecha_per_fin} </Paper>
                              </Grid>
                          </Grid>
                          {///////////////////
                          }
                          <Grid item xs  style={{align: 'center',verticalAlign: 'middle',padding: 0, margin: 0}}>
                            <Paper style={{color:'white',background: 'transparent'
                            ,boxShadow:'inherit'
                              ,padding: 2,paddingBottom: 0, marginRight: 0, marginBottom: movil_pequeño?0:3, borderRadius:0
                              }} align='center' >
                              Matrícula
                            </Paper>
                           <Divider style={{backgroundColor: 'white'}} />
                          </Grid>
                          <Grid container item  style={{verticalAlign:'middle',width:'100%'}}>
                              <Grid item xs >
                                <Paper style={{width:'100%',color: 'white',boxShadow:'inherit',background: 'transparent',padding:5, borderRadius:0, }} align='center'> {props.fecha_mat_inicio} </Paper>
                              </Grid>
                              <Grid item xs>
                                <Paper style={{width:'100%',color:'white',boxShadow:'inherit',background: 'transparent',padding:5, borderRadius:0, }} align='center'> {props.fecha_mat_fin} </Paper>
                              </Grid>
                          </Grid>
            {props.lista_cuotas}
            </Grid>
            </Paper>
          
          </Card>
    );
}

function WidgetFechasNotas(props){
    return(
        <Card className={movil_pequeño?'WidgetFechasNotas-movil':'WidgetFechasNotas-pc'} style={{background: color_fondo}}>
          <CardHeader title={'Fechas Ingreso de Notas'} style={{color: 'white',paddingTop:1,paddingLeft:1,paddingBottom:0}} avatar={<Avatar style={{background: 'transparent'}}>
          <Iconos fontSize='small' icono={'Time'}  />
          </Avatar>} />
         {props.Lista_calificacion} 
        </Card>
    );
}

function WidgetRecorridoAlumno(props){

    return(
        <Card className={movil_pequeño?'WidgetRecorridoAlumno-movil':'WidgetRecorridoAlumno-pc'} style={{background: color_fondo}}>
        <CardHeader title={'Recorrido'} style={{color: 'white',paddingTop:1,paddingLeft:1,paddingBottom:0}} avatar={<Avatar style={{background: 'transparent'}}>
          <Iconos fontSize='small' icono={'Time'}  />
          </Avatar>} />
            {props.porcentaje_planes}
        </Card>
    );
}

function WidgetSaldoAlumno(props){

  return(
      <Card className={movil_pequeño?'WidgetSaldoAlumno-movil':'WidgetSaldoAlumno-pc'} style={{background: color_fondo}}>
          <CardHeader title={''} style={{color: 'white',paddingTop:1,paddingLeft:1,paddingBottom:0}} />
          <div style={{ display: 'flex',justifyContent: 'center',alignItemsitems: 'center',padding:0}}>        
          <Button  startIcon={<Iconos fontSize='small' icono={'PaymentIcon'} />} color='secondary' variant='outlined'  onClick={props.cargar({reporte: 0,i:1,e:1,l:1,pagina: 'Pago_Linea', nombre: 'Pago en línea', descripcion: 'Pago en línea', icono: 'PaymentIcon'}) } style={{  backgroundColor:'white',color: colores.azul,textTransform: 'none',width:'100%', marginLeft:15, marginRight:15}}>               
            Realizar pago    
          </Button>                
          </div>     
      </Card>    
    );
}

/*                                        EXPORT                                      */
export default withStyles(styles)(
    class Widgets extends React.Component {


      constructor(props) {
        super(props);
  
        this.AbrirImagen=props.AbrirImagen
        this.cargar=props.cargar
        this.rol=props.rol
        this.plataforma=props.plataforma
        this.id_control_matricula = props.id_control_matricula;
        this.estado_refresh_widgets=props.estado_refresh_widgets===undefined?0:props.estado_refresh_widgets
        this.interval_widget=props.interval_widget
        this.actualizarsaldopendiente=props.actualizarsaldopendiente

        this.state = {
            isLoggin: false,
            widgets: [],
            lista_cuotas: [],
            lista_cuotas_json:'',
            saldo_pendiente: '',
            porcentaje_planes: [],
            porcentaje_planes_json:'',
            Lista_calificacion: [],
            Lista_calificacion_json:'',
            año: '',
            periodo: '',
            fecha_mat_inicio: '',
            fecha_mat_fin: '',
            fecha_per_inicio: '',
            fecha_per_fin: '',
            WidgetFechas:false,
            WidgetFechas_movil:false,
            WidgetFechasNotas:false,
            WidgetFechasNotas_movil:false,
            WidgetSaldoAlumno:false,
            WidgetSaldoAlumno_movil:false,
            WidgetCalendario:false,
            WidgetCalendario_movil:false,
            WidgetRecorridoAlumno:false,
            WidgetRecorridoAlumno_movil:false,
            actualizacion: new Date(),
            width: 100,
            switch_publi: props.switch_publi
        }
        
    }; //FIN CONSTRUCTORS


componentDidMount()
{
  var _this=this
      _this.Llenado(1);
        if(_this.estado_refresh_widgets===1)
        {
          widgets_interval= setInterval(_this.Llenado, _this.interval_widget);
        }
}

Llenado=(valor)=>{
  var _this=this

  if(valor===1 || (_this.estado_refresh_widgets===1))
  {
    
  var render=false
  if(localStorage.getItem('Tabs_user')===null)
  render=true
  else{
    var json=JSON.parse(localStorage.getItem('Tabs_user')).filter(busqueda2 =>busqueda2.usuario.match( Auth.getProfile().user))
    if(json.length>0)
    if(json[0].tabs.length>0)
    render=false
    else
    render=true
    else
    render=true
  }

  if(render || valor===1)
    try{
        new Request
        .post(`${ip}/validacion_widgets`)
        .set({'authorization': 'Bearer ' + Auth.getToken() })
        .set('Content-Type', 'application/json')
        .send({ID_ROL:_this.rol,ID_PLATAFORMA:_this.plataforma,cuenta_alumno: Auth.getProfile().user})
        .retry(0)
        .timeout({ response: 40000, deadline: 60000, }) 
        .end((err, res) => {
         
          if (err) { 
            if (err.toString().substr(0,16) === 'Error: Forbidden')
            { 
              return;  
            }       
              funciones.showToast('w', 'Tiene problemas de conexión')        
          }

          if(res!==undefined){
          const rows = JSON.parse(res.text);
          if (rows.length > 0) 
          {    
               rows.forEach((value,index)=>{
                if(_this.state[value.NOM_WIDGET]!==undefined){
                 if(_this.state[value.NOM_WIDGET].toString()!==(value.MOSTRAR?true:false).toString()){
                  _this.setState({[value.NOM_WIDGET]: value.MOSTRAR===1?true:false, [value.NOM_WIDGET+'_movil']:value.MOVIL===1?true:false},()=>
                  {
                      if(index===rows.length-1)
                      _this.Validar();          
                  });     
                  }
                  else
                  {
                    if(index===rows.length-1)
                    _this.Validar();
                  }
                }
                else
                {
                  _this.setState({[value.NOM_WIDGET]: value.MOSTRAR===1?true:false})
                }
            })
          }
          }
        })
        }
        catch(ex){
            funciones.showToast('e', 'Error de conexión')
        }
      }
   // })
}

Validar=()=>{
  var _this=this
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          try{
            new Request
            .post(`${ip}/obtener_widget_graficas`)
            .set({'authorization': 'Bearer ' + Auth.getToken() })
            .set('Content-Type', 'application/json')
            .send({ID_CONTROL_MATRICULA:_this.id_control_matricula,ID_PLATAFORMA:_this.plataforma,USUARIO: Auth.getProfile().user})
            .retry(0)
            .timeout({ response: 40000, deadline: 60000, }) 
            .end((err, res) => {
             
              if (err) { 
                if (err.toString().substr(0,16) === 'Error: Forbidden')
                { 
                  return;  
                }       
                this.setState({ openBackDrop: false }, ()=> { 
                  funciones.showToast('w', 'Error de conexión')
                });
              }

              if(res!==undefined)
              {
              const rows = JSON.parse(res.text);
              if (rows.length > 0) 
              {   
                 
                  var widgets =[]
                  var found = null;
                  rows.forEach(
                    function getCheck(text, index) {

                    found = widgets.find(grupo => grupo.NOM_STATE === text.NOM_STATE);
                        if (found == null){
                          if(text.TIPO==='Line' || text.TIPO==='Bar' || text.TIPO==='Pie')
                          {
                            var data=[]
                            var labels=[]
                            var color_label=[]
                            rows.forEach(
                              function getCheck(item, index) {
                                if(item.NOM_STATE===text.NOM_STATE)
                                {
                                  data.push(item.VALOR)
                                  if(text.TIPO!=='Pie')
                                  labels.push(item.LABEL)
                                  else
                                  labels.push([item.LABEL,item.VALOR])

                                  if(text.TIPO==='Pie')
                                  color_label.push(item.COLOR_LABEL)
                                }

                              })

                              widgets.push({NOM_STATE:text.NOM_STATE,TIPO: text.TIPO,MAX: text.MAX,MIN: text.MIN,STEPSIZE: text.STEPSIZE,LABEL_TITULO: text.LABEL_TITULO
                              ,DATA: data,LABELS: labels,BACKGROUND_RGB:text.BACKGROUND_RGB,color_label:color_label
                            });
                        
                          }
                          if(text.TIPO==='Circule')
                          {
                            widgets.push(text)
                        
                          }

                        }else {
                          found = null;
                        
                      }
                  })
                  this.setState({widgets: widgets})    
              }    
              }       
              });       
            }
            catch(ex){
                funciones.showToast('e', 'Error de conexión')
            }

            /////////////////////////////////////////////////////////////////////////////////////////////////////
            if(this.state.WidgetFechasNotas&&(this.state.WidgetFechasNotas_movil===movil_pequeño||!movil_pequeño))
            try{
              Request.get(`${ip}/obtenerfechaponderacion/${ Auth.getProfile().user}/${this.id_control_matricula}`)
              .retry(0)
              .timeout({ response: 40000, deadline: 60000, })
              .end((err, res2)=>{
               if (err) { 
                 if (err.toString().substr(0,16) === 'Error: Forbidden')
                 {
                   return;   
                 }
                 return;
               }
               const tmp2 = JSON.parse(res2.text);
               var jornada='';
               var Lista_calificacion=[]; 
               if( JSON.stringify(this.state.Lista_calificacion_json) !== JSON.stringify(tmp2)){
                Lista_calificacion.push(
                  <Grid key={'Gr6-f'} container item>
                    <Grid key={'Gr5-f'} item xs={2} >
                      
                    </Grid>
                    <Grid key={'Gr4-f'} item xs >
                      <Paper key={'Pa2-f'} style={{background:'transparent',color:'white',padding:5,marginTop:2,marginBottom:2,marginRight:5 ,borderBottom: '0.1mm ridge rgba('+colores.naranja_rgb+', .3)', borderRadius:0}} align='center'>
                      <b>{'Fecha Inicio'}</b>
                      </Paper>
                    </Grid>
                    <Grid key={'Gr4-f'} item xs >
                      <Paper key={'Pa2-f'} style={{background:'transparent',color:'white',padding:5,marginTop:2,marginBottom:2 ,borderBottom: '0.1mm ridge rgba('+colores.naranja_rgb+', .3)', borderRadius:0}} align='center'>
                        <b>{'Fecha Fin'}</b>
                      </Paper>
                    </Grid>
                  </Grid> 
                ); 
               tmp2.forEach( function getCheck(item2, index2) {
                 
                   if(jornada!==item2.JORNADA){
                   jornada=item2.JORNADA
                    Lista_calificacion.push(
                     <Grid key={'Gr61-'+item2.JORNADA+item2.ID_PONDERACION.toString()} container item>
                       
                     <Grid key={item2.JORNADA+item2.ID_PONDERACION.toString()} item xs={2} >
                     <Paper align='center' style={{background:'transparent',color:'white',fontWeight: 'bold',padding: 5, marginRight: 5, marginTop: 4, marginBottom: 0,borderRadius:0}}>
                       {'°'}
                     </Paper>
                     <Divider style={{backgroundColor: 'white',marginBottom:5}}/>
                     </Grid>
                       <Grid key={'Gr7-'+item2.JORNADA} item xs >
                         <Paper key={'Pa4-'+item2.JORNADA} style={{boxShadow:'white',background:'transparent',color:'white',fontWeight: 'bold',padding: 5, marginRight: 0, marginTop: 4, marginBottom: 0, borderRadius:0}} align='center'>{item2.JORNADA}</Paper>
                         <Divider style={{backgroundColor: 'white',marginBottom:5}}/>
                       </Grid>
                       </Grid>
                     );
                     Lista_calificacion.push(
                      <Grid key={'Gr6-'+item2.JORNADA+item2.ID_PONDERACION.toString()+'f'} container item>
                        <Grid key={'Gr5-'+item2.JORNADA+item2.ID_PONDERACION.toString()+'f'} item xs={2} >
                          
                        </Grid>
                        <Grid key={'Gr4-'+item2.JORNADA+item2.ID_PONDERACION.toString()+'f'} item xs >
                          <Paper key={'Pa2-'+item2.JORNADA+item2.ID_PONDERACION.toString()+'f'} style={{background:'transparent',color:'white',padding:5,marginTop:2,marginBottom:2,marginRight:5 ,borderBottom: '0.1mm ridge rgba('+colores.naranja_rgb+', .3)', borderRadius:0}} align='center'>
                          <b>{'Fecha Inicio'}</b>
                          </Paper>
                        </Grid>
                        <Grid key={'Gr4-'+item2.JORNADA+item2.ID_PONDERACION.toString()+'f'} item xs >
                          <Paper key={'Pa2-'+item2.JORNADA+item2.ID_PONDERACION.toString()+'f'} style={{background:'transparent',color:'white',padding:5,marginTop:2,marginBottom:2 ,borderBottom: '0.1mm ridge rgba('+colores.naranja_rgb+', .3)', borderRadius:0}} align='center'>
                          <b>{'Fecha Fin'}</b>
                          </Paper>
                        </Grid>
                      </Grid> 
                    );  
                   }

                    Lista_calificacion.push(
                     <Grid key={'Gr6-'+item2.JORNADA+item2.ID_PONDERACION.toString()} container item>
                       <Grid key={'Gr5-'+item2.JORNADA+item2.ID_PONDERACION.toString()} item xs={2} >
                         <Paper elevation={item2.DESCRIPCION_PONDERACION!==''?3:0} key={'Pa3-'+item2.JORNADA+item2.ID_PONDERACION.toString()} style={{background:'transparent',marginRight:5,borderBottom: item2.DESCRIPCION_PONDERACION!==''?'0.1mm ridge rgba('+colores.naranja_rgb+', .3)':'none',padding:5,marginTop:2,marginBottom:2, borderRadius:0}} align='center'><font color="A0A0A0">{item2.ID_PONDERACION!==5?item2.DESCRIPCION_PONDERACION:'Ext'}</font></Paper>
                       </Grid>
                       <Grid key={'Gr4-'+item2.JORNADA+item2.ID_PONDERACION.toString()} item xs >
                         <Paper elevation={3} key={'Pa2-'+item2.JORNADA+item2.ID_PONDERACION.toString()} style={{background:'transparent',color:'white',padding:5,marginTop:2,marginBottom:2,marginRight:5 ,borderBottom: '0.1mm ridge rgba('+colores.naranja_rgb+', .3)', borderRadius:0}} align='center'>
                         <font color="A0A0A0">{''+item2.FECHA_INICIO+''}</font>
                         </Paper>
                       </Grid>
                       <Grid key={'Gr4-'+item2.JORNADA+item2.ID_PONDERACION.toString()} item xs >
                         <Paper elevation={3} key={'Pa2-'+item2.JORNADA+item2.ID_PONDERACION.toString()} style={{background:'transparent',color:'white',padding:5,marginTop:2,marginBottom:2 ,borderBottom: '0.1mm ridge rgba('+colores.naranja_rgb+', .3)', borderRadius:0}} align='center'>
                         <font color="A0A0A0">{''+item2.FECHA_FIN+''}</font>
                         </Paper>
                       </Grid>
                     </Grid> 
                   );  
               })
               _this.setState({Lista_calificacion:Lista_calificacion,Lista_calificacion_json:tmp2})
               }
             })
           }
           catch(ex){}

           ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
           if(this.state.WidgetFechas&&(this.state.WidgetFechas_movil===movil_pequeño||!movil_pequeño))
           try{
            Request.get(`${ip}/obtenerfechacuota/${this.id_control_matricula}`)
            .retry(0)
            .timeout({ response: 40000, deadline: 60000, })
            .end((err, res2)=>{
              if (err) { 
                if (err.toString().substr(0,16) === 'Error: Forbidden')
                {
                  return;
                }
                return;
              }
              const tmp2 = JSON.parse(res2.text);
              var lista_cuotas=[]
              
              tmp2.forEach( function getCheck(item2, index2) {
                if(item2.TIPO==='MATRICULA'){
                   _this.setState({año: item2.ANIO,periodo: item2.PERIODO,fecha_per_inicio:item2.FECHA_INICIO_PER,fecha_per_fin:item2.FECHA_FIN_PER,fecha_mat_inicio: item2.FECHA,fecha_mat_fin: item2.FECHA_FIN})
                }
                else{
                  return ;
                }
              })
    
              if(JSON.stringify(this.state.lista_cuotas_json)!==JSON.stringify(tmp2))
              {
               lista_cuotas.push(
                <Grid key={'Gr3-Cuotas'} item xs>
                  <Paper elevation={24} key={'Pa-Cuotas'} style={{color:'white',background:'transparent',boxShadow:'inherit',padding: 2, marginRight: 0, marginBottom: 3, marginTop: 3, borderRadius:0}} 
                  align='center'>Cuotas</Paper>
                  <Divider style={{backgroundColor: 'white'}}/>
                </Grid>
              );
              tmp2.forEach( function getCheck(item2, index2) {
                if(item2.TIPO==='CUOTA'){
                   lista_cuotas.push(
                  <Grid key={'Gr-'+item2.SECUENCIA.toString()} container item>
                      <Grid key={'Gr1-'+item2.SECUENCIA.toString()} item xs >
                        <Paper elevation={24}  key={'Pa5-'+item2.SECUENCIA.toString()}  style={{borderBottom: '0.1mm ridge rgba('+colores.naranja_rgb+', .2)',color:'white',boxShadow:'inherit',background:'transparent',padding:2, borderRadius:0, marginRight: 0}} align='center'>{item2.SECUENCIA}</Paper>
                       </Grid>
                    <Grid key={'Gr2-'+item2.SECUENCIA.toString()} item xs >
                      <Paper elevation={24} key={'Pa6-'+item2.SECUENCIA.toString()} style={{borderBottom: '0.1mm ridge rgba('+colores.naranja_rgb+', .2)',color:'white',boxShadow:'inherit',background: 'transparent',padding:2, borderRadius:0, marginRight: 0}} align='center'>{item2.FECHA}</Paper>
                    </Grid>
                  </Grid>
                  );
                  }
              })
              _this.setState({lista_cuotas: lista_cuotas,lista_cuotas_json: tmp2})
            }
            })
          }
          catch(ex){}
          
          /////////////////////////////////////////////////////////////////////////////////////////////////////////
          if(this.state.WidgetRecorridoAlumno&&(this.state.WidgetRecorridoAlumno_movil===movil_pequeño||!movil_pequeño))
          try{
            Request.get(`${ip}/obtenerporcentajecarrera/${ Auth.getProfile().user}`)
            .retry(0)
            .timeout({ response: 40000, deadline: 60000, })
            .end((err, res2)=>{
              if (err) {
                if (err.toString().substr(0,16) === 'Error: Forbidden')
                {
                  return;    
                }
                return;
              }
              const tmp2 = JSON.parse(res2.text);
              if(tmp2.length>0) {
                var porcentaje_planes=[];
                if(JSON.stringify(this.state.porcentaje_planes_json)!==JSON.stringify(tmp2))
                {
                tmp2.forEach( function getCheck(item2, index2) {
                     porcentaje_planes.push(
                      <Paper key={'Pa7-'+item2.DESCRIPCION_NIVEL} style={{boxShadow:'none',background:'transparent',color:'white',margin: 10, padding: 5}}>
                        <Typography key={'Pa8-'+item2.DESCRIPCION_NIVEL} style={{marginBottom: 10, paddingTop: 10, fontSize:11}} variant='body1' align='center'>{item2.DESCRIPCION_NIVEL}</Typography>
                        <PrettoSlider  key={'Pa9-'+item2.DESCRIPCION_NIVEL} onClick={_this.cargar({reporte: 0,i:1,e:1,l:1,pagina: 'Historial_Alumno_estudiante', nombre: 'Historial de Notas', descripcion: 'Historial de Notas', icono: 'Info'})}
                        style={{readOnly: true}} valueLabelDisplay="auto" value={item2.PORCENTAJE} valueLabelFormat={item2.PORCENTAJE+'%'} marks={marks} />
                      </Paper>
                    );
                })
                  _this.setState({porcentaje_planes:porcentaje_planes,porcentaje_planes_json:tmp2})
                }
              }
            })
          }
          catch(ex){}
      }

/*                                          RENDER                          */
render() {
  
    return (    
    <div className={this.plataforma!==1?'div-widgets-noadmin':'div-widgets-admin'}>
                {
                  this.state.widgets.map((text,index,array)=>{
                      if(text.TIPO==='Circule')
                      if(this.state[text.NOM_STATE])
                      return(
                        <WidgetCirculos key={text.NOM_STATE} icono={text.NOM_ICONO} titulo={text.LABEL_TITULO} 
                        label1={text.LABEL_CIRCULE1} label2={text.LABEL_CIRCULE2} label3={text.LABEL_CIRCULE3} 
                        valor1={text.VALOR_CIRCULE1} valor2={text.VALOR_CIRCULE2} valor3={text.VALOR_CIRCULE3} 
                        simbolo1={text.SIMBOLO_CIRCULE1} simbolo2={text.SIMBOLO_CIRCULE2} simbolo3={text.SIMBOLO_CIRCULE3} 
                        porcentaje1={text.PORCENTAJE_CIRCULE1} porcentaje2={text.PORCENTAJE_CIRCULE2} porcentaje3={text.PORCENTAJE_CIRCULE3}
                        BACKGROUND_RGB={text.BACKGROUND_RGB}
                        actualizacion={this.state.actualizacion} />
                      )
                      if(text.TIPO==='Line'){
                        if(this.state[text.NOM_STATE])
                        return(
                          <WidgetLine key={text.NOM_STATE} 
                          max={text.MAX} min={text.MIN} stepSize={text.STEPSIZE} labels={text.LABELS} label={text.LABEL_TITULO} data={text.DATA}
                          BACKGROUND_RGB={text.BACKGROUND_RGB}
                          actualizacion={this.state.actualizacion} />
                        )
                      }
                      if(text.TIPO==='Bar'){
                        if(this.state[text.NOM_STATE])
                        return(
                          <WidgetBar key={text.NOM_STATE} 
                          max={text.MAX} min={text.MIN} stepSize={text.STEPSIZE} labels={text.LABELS} label={text.LABEL_TITULO} data={text.DATA}
                          BACKGROUND_RGB={text.BACKGROUND_RGB}
                          actualizacion={this.state.actualizacion}
                          width={this.state.width} 
                          switch_publi={this.state.switch_publi}
                          />
                        )
                      }
                      if(text.TIPO==='Pie'){
                        if(this.state[text.NOM_STATE])
                        return(
                          <WidgetPie key={text.NOM_STATE} icono={text.NOM_ICONO} labels={text.LABELS} data={text.DATA} label={text.LABEL_TITULO} actualizacion={this.state.actualizacion} switch_publi={this.state.switch_publi}
                            BACKGROUND_RGB={text.BACKGROUND_RGB} color_label={text.color_label}
                          />
                        )
                      }
                      return '';
                  })
                }

                {this.state.WidgetFechas && (this.state.WidgetFechas_movil===movil_pequeño||!movil_pequeño)?
                  <WidgetFechas lista_cuotas={this.state.lista_cuotas} año={this.state.año} periodo={this.state.periodo} fecha_mat_inicio={this.state.fecha_mat_inicio} fecha_mat_fin={this.state.fecha_mat_fin} 
                  fecha_per_inicio={this.state.fecha_per_inicio} fecha_per_fin={this.state.fecha_per_fin}
                  />:null
                }
                {this.state.WidgetFechasNotas && (this.state.WidgetFechasNotas_movil===movil_pequeño||!movil_pequeño)?
                <WidgetFechasNotas Lista_calificacion={this.state.Lista_calificacion}/>:null
                }
                {this.state.WidgetSaldoAlumno && (this.state.WidgetSaldoAlumno_movil===movil_pequeño||!movil_pequeño)?
                <WidgetSaldoAlumno saldo_pendiente={this.state.saldo_pendiente} cargar={this.cargar}/>:null
                }
                {this.state.WidgetRecorridoAlumno && (this.state.WidgetRecorridoAlumno_movil===movil_pequeño||!movil_pequeño)?
                <WidgetRecorridoAlumno porcentaje_planes={this.state.porcentaje_planes}/>:null
                }
      </div>        
    ); /// finaliza return
} /// finaliza render
} /// finaliza class
)/// finaliza withStyles

    